import React, { useCallback } from 'react';

import { TableSortLabel } from '@material-ui/core';
import HeaderSortArrows from './SortingArrows';

const TableSortHeader = ({ children, onSort, identifier, filter }) => {
   const handleClick = useCallback((event) => {
      if (onSort) {
         onSort(identifier);
      }
      event.preventDefault();
   }, [onSort, identifier]);

   return (
      <TableSortLabel
         children={children}
         onClick={handleClick}
         active={filter.sortBy === identifier}
         direction={filter.sortBy === identifier ? filter.orderBy : 'asc'}
         IconComponent={
            (props) => (
               <HeaderSortArrows
                  {...props}
                  active={filter.sortBy === identifier}
                  direction={filter.sortBy === identifier ? filter.orderBy : 'asc'}
               />
            )
         }
      />
   );
};

export default TableSortHeader;
